// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pY","control":"pZ","leftControl":"p0 pZ","rightControl":"p1 pZ","hide":"p2 p6"};